import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Segment, Table, Grid } from "semantic-ui-react";
import "../../../scss/index.scss";
import { estiloSegmento } from "../../../estilos/segmentos";
import { apiUsuario } from "../../../api/usuario";
import { ENTORNO } from "../../../utils/constantes";
import { getrole, setTitulo } from "../../../utils/variablesLocales";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import CssBaseline from "@mui/material/CssBaseline";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Fab from "@mui/material/Fab";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Fade from "@mui/material/Fade";
import IconButton from "@mui/material/IconButton";
import HomeIcon from "@mui/icons-material/Home";
import { Form } from "semantic-ui-react";
import { TextField } from "@mui/material";
import logoLocalPoint from "../../../imagenes/logoConNombre.png";

const apiusuario = new apiUsuario();

function ScrollTop(props) {
  const { children, window } = props;
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = (event) => {
    const anchor = (event.target.ownerDocument || document).querySelector(
      "#back-to-top-anchor"
    );

    if (anchor) {
      anchor.scrollIntoView({
        block: "center",
      });
    }
  };

  return (
    <Fade in={trigger}>
      <Box
        onClick={handleClick}
        role="presentation"
        sx={{ position: "fixed", bottom: 16, right: 16 }}
      >
        {children}
      </Box>
    </Fade>
  );
}

ScrollTop.propTypes = {
  children: PropTypes.element.isRequired,
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export function UsuarioConsulta(props) {
  const [localidadSeleccionada, setLocalidadSeleccionada] = useState("");
  const [rolSeleccionado, setRolSeleccionado] = useState("");
  const [nombreIngresado, setNombreIngresado] = useState("");
  const [apellidoIngresado, setApellidoIngresado] = useState("");
  const [emailIngresado, setEmailIngresado] = useState("");

  setTitulo("Usuarios");

  const navigate = useNavigate();

  const navigateToInicio = async () => {
    navigate(ENTORNO.URL_APLICACION + "/Administrador/Inicio");
  };

  ////////////////////////////////

  const [usuarios, setUsuario1] = useState(null);
  const [yaCargo, setyaCargo] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        //controlando la seguridad para que solo acceda a esta pantalla el perfil que corresponda
        if (getrole() !== "Administrador") {
          navigate(ENTORNO.URL_APLICACION + "/CerrarSesion");
        }
        ///////////////////////////////////////////////////////

        if (!yaCargo) {
          const response = await apiusuario.obtenerTodosConFiltros(
            localidadSeleccionada,
            rolSeleccionado,
            nombreIngresado,
            apellidoIngresado,
            emailIngresado
          );
          setyaCargo(true);
          setUsuario1(response);
        }
      } catch (error) {
        console.error(error);
      }
    })();
  });

  ////////////////////////////////

  var usuarioRegistros = [];

  if (usuarios) {
    for (let i = 0; i < usuarios.length; i++) {
      //Localidad, Nombre, Apellido, role, email, EstadoConductor, Viaje_IdViaje, Viaje_Pasajero, Viaje_Estado

      usuarioRegistros.push({
        id: usuarios[i]._id,
        Localidad: usuarios[i].Localidad,
        Nombre: usuarios[i].Nombre,
        Apellido: usuarios[i].Apellido,
        role: usuarios[i].role,
        email: usuarios[i].email,
        EstadoConductor: usuarios[i].EstadoConductor,
        Viaje_IdViaje: usuarios[i].Viaje_IdViaje,
        Viaje_Pasajero: usuarios[i].Viaje_Pasajero,
        Viaje_Estado: usuarios[i].Viaje_Estado,
      });
    }
  }

  const filtrar = async () => {
    const response = await apiusuario.obtenerTodosConFiltros(
      localidadSeleccionada,
      rolSeleccionado,
      nombreIngresado,
      apellidoIngresado,
      emailIngresado
    );
    setUsuario1(response);
  };

  return (
    <div style={{ overfxlow: "hidden", touchAction: "none" }}>
      <React.Fragment>
        <CssBaseline />
        <AppBar style={{ background: "#DC030E" }}>
          <Toolbar>
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              onClick={navigateToInicio}
              aria-label="menu"
              sx={{ mr: 2 }}
            >
              <HomeIcon />
            </IconButton>
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
              Usuarios - Consulta
            </Typography>
            <img
              src={logoLocalPoint}
              style={{ marginTop: "1px" }}
              width="75"
              alt="Logo"
            />
          </Toolbar>
          <Toolbar style={{ backgroundColor: "white" }}>
            <Typography component="div" sx={{ flexGrow: 1 }}>
              <Form.Dropdown
                name="localidad"
                placeholder="[Localidad...]"
                selection
                onChange={(_, data) => {
                  setLocalidadSeleccionada(data.value);
                }}
                options={[
                  {
                    key: "",
                    text: "[Localidad...]",
                    value: "",
                  },
                  {
                    key: "El Calafate",
                    text: "El Calafate",
                    value: "El Calafate",
                  },
                  {
                    key: "Valencia",
                    text: "Valencia",
                    value: "Valencia",
                  },
                  {
                    key: "Córdoba",
                    text: "Córdoba",
                    value: "Córdoba",
                  },
                  {
                    key: "Ushuaia",
                    text: "Ushuaia",
                    value: "Ushuaia",
                  },
                  {
                    key: "Santiago del Estero",
                    text: "Santiago del Estero",
                    value: "Santiago del Estero",
                  },
                  {
                    key: "Colonia Caroya",
                    text: "Colonia Caroya",
                    value: "Colonia Caroya",
                  },
                ]}
              ></Form.Dropdown>
            </Typography>
            <Typography component="div" sx={{ flexGrow: 1 }}>
              <Form.Dropdown
                name="role"
                placeholder="[Rol (*)...]"
                selection
                onChange={(_, data) => {
                  setRolSeleccionado(data.value);
                }}
                options={[
                  {
                    key: "",
                    text: "[Rol (*)...]",
                    value: "",
                  },
                  {
                    key: "Pasajero",
                    text: "Pasajero",
                    value: "Pasajero",
                  },
                  {
                    key: "Conductor",
                    text: "Conductor",
                    value: "Conductor",
                  },
                ]}
              ></Form.Dropdown>
            </Typography>
            <Typography component="div" sx={{ flexGrow: 1 }}>
              <TextField
                id="nombre"
                placeholder="Nombre"
                variant="standard"
                name="nombre"
                onChange={(e, data) => {
                  setNombreIngresado(e.target.value);
                }}
                type="text"
              />
            </Typography>
            <Typography component="div" sx={{ flexGrow: 1 }}>
              <TextField
                id="apellido"
                placeholder="Apellido"
                variant="standard"
                name="apellido"
                onChange={(e, data) => {
                  setApellidoIngresado(e.target.value);
                }}
                type="text"
              />
            </Typography>
            <Typography component="div" sx={{ flexGrow: 1 }}>
              <TextField
                id="email"
                placeholder="Email"
                variant="standard"
                name="email"
                onChange={(e, data) => {
                  setEmailIngresado(e.target.value);
                }}
                type="text"
              />
            </Typography>
            <Typography component="div">
              <Form.Button name="filtrar" onClick={filtrar}>
                Filtrar
              </Form.Button>
            </Typography>
          </Toolbar>
        </AppBar>
        <Toolbar id="back-to-top-anchor" />
        <Container>
          <Box sx={{ flexGrow: 1 }}></Box>
          <Box sx={{ my: 2 }}>
            <Segment style={estiloSegmento.Administrador}>
              <Grid textalign="center" container style={{ padding: "5em 0em" }}>
                <div>
                  <Grid.Row style={{ width: "100%" }}>
                    <Grid.Column style={{ width: "100%" }}>
                      <Segment style={estiloSegmento.Administrador}>
                        <Table compact celled id="tablaTextos">
                          <Table.Header>
                            <Table.Row>
                              <Table.HeaderCell textAlign="center">
                                Localidad
                              </Table.HeaderCell>
                              <Table.HeaderCell textAlign="center">
                                Nombre y Apellido
                                <br></br>
                                Rol
                              </Table.HeaderCell>
                              <Table.HeaderCell textAlign="center">
                                Email
                              </Table.HeaderCell>
                              <Table.HeaderCell textAlign="center">
                                Estado conductor
                              </Table.HeaderCell>
                              <Table.HeaderCell textAlign="center">
                                Viaje asignado<br></br>
                                (Id, Pasajero, Estado)
                              </Table.HeaderCell>
                            </Table.Row>
                          </Table.Header>
                          <Table.Body id="tablaTextos">
                            {usuarioRegistros.map((fila, key) => (
                              <Table.Row key={key}>
                                <Table.Cell textAlign="center">
                                  {fila.Localidad}
                                </Table.Cell>
                                <Table.Cell textAlign="center">
                                  {fila.Nombre}, {fila.Apellido}
                                </Table.Cell>
                                <Table.Cell textAlign="center">
                                  {fila.email}
                                </Table.Cell>
                                <Table.Cell textAlign="center">
                                  {fila.EstadoConductor}
                                </Table.Cell>
                                <Table.Cell textAlign="center">
                                  {fila.Viaje_Pasajero}
                                  {fila.Viaje_Pasajero !== "" ? (
                                    <br></br>
                                  ) : (
                                    <div></div>
                                  )}
                                  {fila.Viaje_Estado}
                                  {fila.Viaje_Estado !== "" ? (
                                    <br></br>
                                  ) : (
                                    <div></div>
                                  )}
                                  {fila.Viaje_IdViaje}
                                </Table.Cell>
                              </Table.Row>
                            ))}
                          </Table.Body>
                        </Table>
                      </Segment>
                    </Grid.Column>
                  </Grid.Row>
                </div>
              </Grid>
            </Segment>
          </Box>
          <Box
            sx={{
              position: "fixed",
              bottom: 10,
              right: 10,
              "& > :not(style)": { m: 1 },
            }}
          >
            <Fab
              style={{
                background: "#153B5E",
                color: "white",
                display: "none",
              }}
              aria-label="add"
            ></Fab>
          </Box>
        </Container>
        <ScrollTop {...props}>
          <Fab size="small" aria-label="scroll back to top">
            <KeyboardArrowUpIcon />
          </Fab>
        </ScrollTop>
      </React.Fragment>
    </div>
  );
}
